import type { IPromiseBasedObservable } from "mobx-utils";
import type { SFUserSchema } from "@whatslly/types/analytics/AnalyticsSFTypes";
import type { LoginProviderType } from "@whatslly/types/LoginProviderType";

export type OrgOption = {
  label: string;
  value: string;
  description?: string;
};

export type SelectedOrg = {
  label: string;
  value: string;
  accountId?: string;
  wPod?: string;
  description?: string;
  orgType?: string;
} | null;

export type ChangeOrganizationIdentityPayload = {
  newName: string;
  description?: string;
  orgType?: string;
  isActive: boolean;
  isPOC: boolean;
  POCExpiration?: string;
  org_partner: string;
  defaultLanguage: string;
  serverlocation: string;
  available_crm: string;
};

export interface IOrganizationStore {
  // Computed properties
  selectedOrg: IPromiseBasedObservable<SelectedOrg>;
  orgId: IPromiseBasedObservable<string>;
  wPod: IPromiseBasedObservable<string | undefined>;
  isViewingOtherOrg: boolean;
  isInternalProd: boolean;
  primaryLoginProvider: LoginProviderType;
  isSameOrganization: boolean;
  isAccountOrg: boolean;
  isCrmOrg: boolean | undefined;
  usersList: IPromiseBasedObservable<(SFUserSchema & { userId: string })[]>;

  // Methods
  searchOrgs(value: string): Promise<{ options: OrgOption[] }>;
  getOrgById(orgId: string | undefined): Promise<SelectedOrg>;
  changeOrgName(payload: ChangeOrganizationIdentityPayload): Promise<boolean | undefined>;
  createNewOrg(orgAccountId?: string): Promise<boolean | undefined>;
}

export const InjectOrganizationStore = Symbol.for("OrganizationStore");
